import React from 'react'
import { Typography, Box, useMediaQuery, useTheme } from '@mui/material'
import {
  IMAGE_BASE_PATH_DBRADC,
  IMAGE_BASE_PATH_COMMON,
} from '../../Config/Config'

const MVComponent = ({ getdata }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))

  const data = getdata

  // Common image props
  const imageProps = {
    style: {
      width: '100%',
      height: isMobile ? '200px' : isTablet ? '280px' : '330px',
      objectFit: 'contain',
      marginTop: theme.spacing(isMobile ? 2 : 4),
    },
    onError: (e) => {
      e.target.src =
        IMAGE_BASE_PATH_COMMON + 'Placeholders/Placeholder_Image.jpg'
    },
  }

  // Check if data has content_type (new structure)
  if (data.content_type) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        minHeight="100%"
        textAlign="center"
        px={isMobile ? 2 : 0}
      >
        <Box>
          <Typography
            variant="h4"
            mb={isMobile ? 1 : 2}
            sx={{ fontWeight: 500 }}
          >
            {data.content_type}
          </Typography>
          <Typography
            variant={isMobile ? 'body2' : 'subtitle2'}
            color="text.secondary"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textAlign: 'center',
              px: isMobile ? 1 : 0,
            }}
          >
            {data.content}
          </Typography>
        </Box>
        <Box>
          <img
            {...imageProps}
            src={
              data.image_url === ''
                ? IMAGE_BASE_PATH_COMMON + 'Placeholders/Placeholder_Image.jpg'
                : IMAGE_BASE_PATH_DBRADC + data.image_url
            }
            alt="MV-Data"
          />
        </Box>
      </Box>
    )
  } else {
    // Render as usual if data does not contain content_type (old structure)
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        minHeight="100%"
        textAlign="center"
        px={isMobile ? 2 : 0}
      >
        <Box>
          <Typography
            variant={isMobile ? 'h6' : 'h5'}
            mb={isMobile ? 1 : 2}
            sx={{ fontWeight: 500 }}
          >
            {data.title}
          </Typography>
          <Typography
            variant={isMobile ? 'body2' : 'subtitle2'}
            color="text.secondary"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textAlign: 'center',
              px: isMobile ? 1 : 0,
            }}
          >
            {data.description}
          </Typography>
        </Box>
        <Box>
          <img
            {...imageProps}
            src={
              data.image === ''
                ? IMAGE_BASE_PATH_COMMON + 'Placeholders/Placeholder_Image.jpg'
                : data.image
            }
            alt="MV-Data"
          />
        </Box>
      </Box>
    )
  }
}

export default MVComponent
